import React, { useContext } from "react";
import { ExpandableContainer } from "@bloomberg/media-ui-markets";
import { ScreenContext } from "@foundation/screen";
import type { ExpandableContainerProps } from "@bloomberg/media-ui-markets/types/ExpandableContainer";
import styles from "./executives.module.css";
import { getDisplayedRowsCount } from "~utils/executiveUtils";
import { useTranslateMessage } from "~utils/i18n";

export default function Executives(props: ExpandableContainerProps) {
  const {
    breakpoints: { tablet, smallDesktop },
  } = useContext(ScreenContext);

  const { people } = props;

  const translateMessage = useTranslateMessage();
  const executivesTitle = `${translateMessage({
    id: "executives",
    defaultMessage: "Executives",
  })} `;

  if (!people?.length) {
    return null;
  }

  const displayedRowsCount = getDisplayedRowsCount(tablet, smallDesktop);

  return (
    <ExpandableContainer
      {...props}
      containerTitle={executivesTitle}
      displayedRowsCount={displayedRowsCount}
      className={styles.executivesContainer}
    />
  );
}
